<template>
  <v-container class="h-700 container-download">
    <v-row justify="center" class="h-100 flex-column" align="center">
      <div class="card-main">
        <v-col
          class="text-subtitle-1 text-center"
          cols="12"
        >
          <v-row style="justify-content: center;" class="mt-7">
            <v-col cols="12" class="text-line-or">
              <v-col cols="2">
                <!-- <div class="line-Horizontal-red"></div> -->
              </v-col>
              <v-col cols="7">
                <div class="title-sub">บริการประทับรับรองเวลาอิเล็กทรอนิกส์ลงบนเอกสาร (e-Timestamp)</div>
              </v-col>
              <v-col cols="2">
                <!-- <div class="line-Horizontal-red"></div> -->
              </v-col>
            </v-col>
          </v-row>
        </v-col>
        <div class="card-upload">
          <div class="text-success mb-10" v-if="this.$store.state.pdfData !== ''">
            <v-icon class="mr-3" color="green">mdi-check-circle</v-icon>
            เอกสารได้รับการประทับ Timestamp เสร็จสมบูรณ์
          </div>
          <div class="btn-download mb-15">
            <v-btn outlined color="primary" x-large @click="downloadpdf()" :disabled="this.$store.state.pdfData === ''">
              <v-icon class="mr-3" color="primary">mdi-download</v-icon>
              ดาวน์โหลดเอกสาร
            </v-btn>
          </div>
          <v-row style="justify-content: center;">
            <v-col cols="4" class="text-line-or">
              <v-col cols="3">
                <div class="line-Horizontal"></div>
              </v-col>
              <v-col cols="4">
                <div class="text-or">หรือ</div>
              </v-col>
              <v-col cols="3">
                <div class="line-Horizontal"></div>
              </v-col>
            </v-col>
          </v-row>
          <br>
          <div class="btn-download mb-10">
            <v-btn outlined color="#4CACBC" x-large @click="linktoUrlOnebox" disabled>
              <img src="@/assets/Onebox_logo.png" altsrcset width="28px" class="mr-5"/>
              จัดเก็บบน One Box
            </v-btn>
          </div>
          <div class="btn-back">
            <a class="text-back" @click="goIndex">ย้อนกลับ</a>
          </div>
        </div>
      </div>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data () {
    return {
      file: null,
      dragging: false
    }
  },
  methods: {
    downloadpdf () {
      const linkSource = `data:application/pdf;base64,${this.$store.state.pdfData}`;
      const downloadLink = document.createElement("a");
      const fileName = this.$store.state.fileName;
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
    },
    linktoUrlOnebox () {
      window.open('https://box.one.th')
    },
    goIndex() {
      this.$router.push("/dashboard");
    },
  }
}
</script>
<style>
.btn-back {
  margin-top: 12px;
  /* color: #8e8e93; */
  font-size: 14px;
  /* color: #008ce8; */
  display: flex !important;
  margin: 4px 0px 0px 0px;
  justify-content: center !important;
}
.text-back {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  margin-bottom: 25px;
}
.text-success {
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 20px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #46B400;
  justify-content: center;
  padding-top: 5px;
}
.container {
  max-width: inherit !important;
}
.card-main {
  /* border: 1px solid rgba(0, 0, 0, 0.12); */
  border-radius: 20px;
  min-width: auto;
  transition: all 0.5s;
  border: 2px solid #63A038;
  /* padding: 24px 70px; */
  background: #fff;
  position: relative;
  margin: 50px 0px 0px 0px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
.h-100 {
  height: 100% !important;
}
.h700 {
  height: 700px !important;
}
.container-download {
  width: 100% !important;
  overflow: auto;
  max-width: 100%;
  height: 100%;
  /* background-color: white; */
  /* background-repeat: no-repeat;
  background-size: cover;
  background: url("../../assets/รูปภาพ1.png") no-repeat;
  background-size: cover;
  background-blend-mode: soft-light; */
  background: url("../../assets/bg-home.jpg") no-repeat,
  linear-gradient(180deg, rgb(255, 255, 255) 0%, #d6eec1 65%, #d6eec1 100%);
  background-position: top center;
  background-size: cover;
  background-blend-mode: soft-light;
}
.text-line-or {
  display: inline-flex;
  margin-top: -42px;
  justify-content: center;
}
.text-or {
  font-family: Sarabun;
  font-style: normal;
  font-weight: 300;
  font-size: 18px;
  line-height: 20px;
  text-align: center;
  color: #AEAEAE;
  margin-top: 4px;
}
.line-Horizontal {
  content: "";
  display: inline-block;
  height: 0.5em;
  vertical-align: bottom;
  width: 100%;
  border-top: 1.5px solid #EEEEEE;
}
.line-Horizontal-green {
  content: "";
  display: inline-block;
  height: 0.5em;
  vertical-align: bottom;
  width: 100%;
  border-top: 3px solid #63A038;
}
.btn-download {
  justify-content: center !important;
  display: flex;
}
.text-select-upload {
  font-family: Sarabun;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 20px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #AEAEAE;
  justify-content: center;
  padding-top: 5px;
}
.title-sub {
  font-size: 26px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.29px;
  text-align: center;
  color: #474554;
  text-align: center;
  margin-bottom: 24px;
}
@media (min-width: 1904px) {
  .container {
    max-width: 1918px !important;
  }
}
</style>
